import { useState } from "react";
import { Phone, PhoneCall, Copy, Check } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { QRCodeSVG } from "qrcode.react";
import { Button } from "./button";

interface PhoneQRDialogProps {
  phoneNumber: string;
  children: React.ReactNode;
}

export function PhoneQRDialog({ phoneNumber, children }: PhoneQRDialogProps) {
  const [copied, setCopied] = useState(false);
  const telUri = `tel:${phoneNumber}`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        className="overflow-hidden border-0 bg-transparent p-0 shadow-none sm:max-w-[280px]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="rounded-2xl bg-white shadow-2xl ring-1 ring-gray-200/50">
          <div className="p-6">
            {/* QR Code */}
            <div className="mx-auto mb-5 w-fit rounded-xl bg-gray-50 p-4">
              <QRCodeSVG
                value={telUri}
                size={160}
                level="M"
                bgColor="transparent"
                fgColor="#111827"
              />
            </div>

            {/* Phone number with copy */}
            <button
              onClick={handleCopy}
              className="group mb-3 flex w-full items-center justify-center gap-2 rounded-lg py-1 transition-colors hover:bg-gray-50"
            >
              <span className="font-mono text-lg font-medium text-gray-900">{phoneNumber}</span>
              {copied ? (
                <Check className="h-4 w-4 text-emerald-500" />
              ) : (
                <Copy className="h-4 w-4 text-gray-400 transition-colors group-hover:text-gray-600" />
              )}
            </button>

            {/* Call button */}
            <Button asChild variant="outline" className="w-full">
              <a href={telUri}>
                <PhoneCall className="mr-2 h-4 w-4" />
                Call from this device
              </a>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
